import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  CircularProgress,
  FormControl,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
  TextField,
  Grid,
} from "@material-ui/core";
import { Backdrop } from "@material-ui/core";
import DebugTable from "../Tables/DebugTable";

const DebugDialog = ({
  open,
  handleClose,
  debugData,
  setDebugData,
  submit,
  status,
  selectedRole
}) => {
  
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      style={{ width: "100%" }}
    >
      <DialogTitle>
        {/* <TextField
          id="outlined-basic"
          label="Search"
          variant="outlined"
          // value={search_val}
          size="small"
          // onChange={multiVal}
        /> */}
      </DialogTitle>
      <DialogContent>
        <DebugTable
          debugData={debugData}
          setDebugData={setDebugData}
          deletee={true}
          loading={false}
          status = {status}
          selectedRole={selectedRole}
        />
      </DialogContent>

      <DialogActions>
        <Button color="secondary" variant="contained" onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DebugDialog;
